<template>
  <div class="tinymce-editor">
    <template v-if="!titleEditorShow" >
      <div 
        class="tinymce-editor-html el-tiptap-editor__content"
        @click="settitleEditorShow($event)" 
        v-if="childValue && childValue != '<p></p>'"
        v-html="childValue"
      ></div>
      <div 
        class="tinymce-editor-html-empty"
        @click="settitleEditorShow($event)" 
        v-else
      >{{$t('main.PleaseEnterContent')}} …</div>
    </template>
    <el-tiptap
      ref="tinymceEditor"
      v-else-if="titleEditorShow"
      :class="[`tinymce-editor-${qid}`, {'tinymce_bubble': isFocus}]"
      v-model="childValue"
      :extensions="extensions"
      :placeholder="`${$t('main.PleaseEnterContent')} …`"
      :charCounterCount="false"
      @onFocus="focus"
      @onBlur="blur"
      @onUpdate="onUpdateEvent"
      @onTransaction='onTransaction'
      @onPaste="onPasteEvent"
      @onInit="onInit"
    >
    </el-tiptap>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex"
import {
    // 需要的 extensions
  Doc,
  Text,
  Paragraph,
  Heading,
  Bold,
  TextColor,
  Underline,
  Italic,
  Strike,
  ListItem,
  Image,
  FontSize,
} from "element-tiptap"
import TextHtml from './myExtension/myExtension'
import SuperscriptMark from './superscript/superscriptMark'
import SubscriptMark from './subscript/subscriptMark'
import QuesAppoint from './quesAppoint/quesAppoint.js'
import ClearFormat from './clearFormat/clearFormat.js'
import InsertSpaceFiller from './insertSpaceFiller/insertSpaceFiller.js'
import $ from 'jquery'
export default {
  name:'TitleEditor',
  props: {
      value: String,    // 接受父组件传递的值
      qid: String,
      isTest: Boolean,
      actionTitleEditorShow: Boolean,
      isAcross: Boolean, // 是否为横向填空题型
  },
  data() {
    return {
      extensions: [],
      childValue: '',
      editor: {},
      textHtmlValue: {},
      titleEditorShow: false,
      isFocus: false
    };
  },
  computed:{
    ...mapState(['citableQuesList', 'headers']),
    id(){
        let id
        if (sessionStorage.getItem('examId')) {
            id = sessionStorage.getItem('examId')
        } else if (sessionStorage.getItem('wid')) {
            id = sessionStorage.getItem('wid')
        }
        return id
    },
  },
  watch: {
    value(newV) {
      this.childValue = newV
    },
    childValue(newValue) {
      this.$emit('childValueChange', newValue)
    },
    actionTitleEditorShow (newValue) {
      this.titleEditorShow = newValue
    }
  },
  created() {
    this.childValue = this.value
    this.setExtensions(this.childValue)
  },
  mounted() {
  },
  methods: {
    ...mapMutations(['setHtmlEditor', 'removeHtmlEditor']),
    settitleEditorShow() {
      this.titleEditorShow = true;
    },
    setExtensions (childValue) {
      this.textHtmlValue = new TextHtml({bubble: true, 
      updateHtml:(text) =>{
        this.childValue = text;
      },
      menubar: false, value: childValue})
      this.extensions = [
        this.textHtmlValue,
        new Doc({ bubble: true, menubar: false }),
        new Text({ bubble: true, menubar: false }),
        new Paragraph({ bubble: true, menubar: false }),
        new FontSize({ bubble: true, menubar: false }),
        
        new Heading({ level: 5, bubble: true, menubar: false }),
        new Bold({ bubble: true, menubar: false }),
        new TextColor(
          {
            colors: [
              '#ffffff', '#000000', '#485368', '#2972f4', '#00a3f5', '#319b62', '#de3c36', '#f88825', '#f5c400', '#9a38d7', '#10ab97',
              '#bfbfbf', '#3f3f3f', '#808b9e', '#99beff', '#99ddff', '#98d7b6', '#ff9c99', '#ffba84', '#ffe270', '#d58eff',
            ],
            bubble: true, menubar: false
          }
        ),
        new Underline({ bubble: true, menubar: false }),
        new Italic({ bubble: true, menubar: false }),
        new Strike({ bubble: true, menubar: false }),
        new ListItem({ bubble: true, menubar: false }),
        new SuperscriptMark({ bubble: true, menubar: false }),
        new SubscriptMark({ bubble: true, menubar: false }),
        new Image({ urlPattern: '', 
           uploadRequest: (file) => {
            // console.log(file)
            return new Promise(resolve => {
              this.uploadImage(file, resolve)
            })
          },
        bubble: true, menubar: false }),
        // new Blockquote(),
        // new TextAlign({ bubble: true, menubar: false }),
        // new BulletList({ bubble: true, menubar: false }),
        // new OrderedList({ bubble: true, menubar: false }),
        // new TodoItem({ bubble: true, menubar: false }),
        // new TodoList({ bubble: true, menubar: false }),
        // new Indent({ bubble: true, menubar: false }),
        // new HardBreak({ bubble: true, menubar: false }),
        // new HorizontalRule(),
        // new History()
        // new Iframe(),
        new QuesAppoint({bubble: this.isTest ? true : false, menubar: false}),
        new ClearFormat({bubble: true, menubar: false}),
        new InsertSpaceFiller({bubble: this.isAcross, menubar: false}),
      ]
    },
    focus() {
      this.isFocus = true
      // console.log(this.childValue)
      this.$store.commit('setHtmlEditor', this.childValue)
      let dev = document.getElementsByClassName(`${this.qid}`).item(0)
      dev.getElementsByClassName("el-tiptap-editor__menu-bubble")[0].classList.add("el-tiptap-editor__menu-bubble--active")
    },
    blur() {
      this.isFocus = false
      let dev = document.getElementsByClassName(`${this.qid}`).item(0)
      this.childValue = this.setMaxWidthForImages(this.childValue)
      dev.getElementsByClassName("el-tiptap-editor__menu-bubble")[0].classList.remove("el-tiptap-editor__menu-bubble--active")
    },
    setMaxWidthForImages(htmlString) {
      // 创建一个临时的 DOM 容器来解析 HTML 字符串
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlString;
      // 获取所有 class 为 image-view__body__image 的 img 标签
      const images = tempDiv.querySelectorAll('img');

      // 遍历每一个 img 标签并设置其 style 属性
      images.forEach(img => {
          img.style.maxWidth = '100%';
      });

      // 返回修改后的 HTML 字符串
      return tempDiv.innerHTML;
    },
    onUpdateEvent(e) {
    },
    onTransaction(e) {
    },
    onInit(e) {
      this.isFocus = true
      // this.editor = e.editor
      // console.log(`onInit: ${e}`)
      // console.log(e)
    },
    onPasteEvent(e) {
      // 将粘贴的图片base64图片替换为网址图片
      if (event && event.clipboardData && event.clipboardData.items.length > 0) {
        for (let i = 0; i < event.clipboardData.items.length; i++) {
          const item = event.clipboardData.items[i];
          if (item.kind === 'file' && item.type.startsWith('image/')) {
            const file = item.getAsFile();
            this.uploadImage(file);
          }
        }
      }
      return false
    },
    async uploadImage(file, resolve) {
      var formData = new FormData()
      formData.append('file', file)
      formData.append('biz', 'upDataWj')
      let that = this
      $.ajax({
          url: `${this.$config.service.uploadApi}`,
          type: 'POST',
          data: formData,
          miniType: 'multipart/form-data',
          contentType: false,
          processData: false,
          success: await function(data) {
              if (resolve) {
                resolve(data.message)
              } else {
                that.childValue = that.replaceBase64ImageSrc(that.childValue, data.message)
              }
          },
          error: function() {
              alert('上传失败！');
          }
      })
    },
    replaceBase64ImageSrc(htmlString, src) {
      // 
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, 'text/html');
      const images = doc.querySelectorAll('img');
      images.forEach(img => {
          if (img.src.startsWith('data:image')) {
              img.src = src;
              img.style = 'max-width: 100%';
          }
      });
      return doc.body.innerHTML;
      }
  },
  beforeDestroy() {
    sessionStorage.removeItem(this.qid)
  }
};
</script>
<style scoped lang="scss">

/deep/.el-tiptap-editor{
    height: inherit !important;
    // width: 80% !important;
    border-radius: 0px !important;
    
}
/deep/.el-tiptap-editor>.el-tiptap-editor__content{
    background: rgba(255, 255, 255,0);
    border: none !important;
    padding: 0 !important;
    word-break: break-all;
    color: #606266;
    /deep/p {
    min-height: 1em;
  }
}
/deep/.el-tiptap-editor__footer {
    display: none !important;
}
/deep/.el-tiptap-editor__menu-bar {
    // display: none !important;
    border: none !important;
    width: max-content !important;
    position: absolute;
    white-space: nowrap;
    z-index: 4;
    background-color: #fff;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
    border-radius: 2px;
    padding: 0 2px;
    display: flex;
    box-sizing: border-box;
    justify-content: center;
    align-items: center;    
    top: 44px;
}
/deep/.el-tiptap-editor__menu-bar:before {
    display: none;
}
/deep/.ProseMirror,
.tinymce-editor-html,
.tinymce-editor-html-empty{
    line-height: 30px;
    
}
.tinymce-editor-html{
  // font-size: 12px;
  font-family: sans-serif;
  color: #606266;
  word-break: break-word;
}
.tinymce-editor-html-empty{
  font-family: sans-serif;
  color: #c0c4cc;
  word-break: break-word;
}
/deep/.el-tiptap-editor__menu-bubble{
  transform: translateY(-70%) !important;
  // z-index: 999 !important;
  // opacity:1 !important;
  //     visibility: inherit !important;
  // left: 20% !important;
//   bottom: 38px !important;
}
/deep/.el-tiptap-editor__menu-bubble--active {
  // left: 20% !important;
  // bottom: 20% !important;
}
/deep/.el-tiptap-editor__command-button{
    width: 20px !important;
    height: 20px !important;
}
/deep/ .item{
  margin-right: 0 !important;
}
/deep/.el-tiptap-editor__menu-bubble{
  z-index: 9999 !important;
}
.tinymce_bubble{
  background-color: #f4f4f4;
}
/deep/.border-bottom-radius{
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
}
</style>
<style lang="scss">
.tinymce-editor p{
  min-height: 30px;
  word-break: break-all;
}
</style>